export const backgearoptions = [
	  { value: 'Dual Kitana', label: 'Dual Kitana', parm: 'backgear' },
	  { value: 'Gun', label: 'Gun', parm: 'backgear' },
	  { value: 'Hoverboard', label: 'Hoverboard', parm: 'backgear' },
	  { value: 'Jetpack', label: 'Jetpack', parm: 'backgear' },
	  { value: 'Pack', label: 'Pack', parm: 'backgear' },
	  { value: 'Robot Arms', label: 'Robot Arms', parm: 'backgear' },
	  { value: 'Sword', label: 'Sword', parm: 'backgear' },
	  { value: 'Wand Backpack', label: 'Wand Backpack', parm: 'backgear' },
];